"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportsV2Url = exports.getAccHostname = exports.getApigeeUrl = exports.getRelationshipServiceUrl = exports.getAdminConstructionApiUrl = exports.getAdminApiUrl = exports.getAdminV1Url = exports.getAdminUrl = exports.getOxygenUrl = exports.getLoginUrl = exports.getEnvValue = exports.init = exports.getEnv = exports.clearEnvFromUrl = exports.getRegion = exports.clearRegionFromUrl = exports.getRegionFromUrl = void 0;
var envConsts_1 = require("./envConsts");
var warn = function (message) {
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        console && console.warn && console.warn(message);
    }
};
var regionFromUrl;
var getRegionFromUrl = function () {
    if (regionFromUrl)
        return regionFromUrl;
    var currentHostname = window.location.hostname;
    if (!currentHostname) {
        return regionFromUrl;
    }
    if (currentHostname.includes('.eu.') || currentHostname.endsWith('.eu')) {
        regionFromUrl = envConsts_1.REGIONS.EMEA;
    }
    return regionFromUrl;
};
exports.getRegionFromUrl = getRegionFromUrl;
var stripProtocolFromUrl = function (url) { return url.split('//')[1]; };
var clearRegionFromUrl = function () {
    regionFromUrl = undefined;
};
exports.clearRegionFromUrl = clearRegionFromUrl;
/**
 * Returns one of `REGIONS` values according to `REACT_APP_ACS_REGION` environment variable.
 * Fallback to `US` if not exist.
 */
var getRegion = function () {
    var fromEnv = process.env.REACT_APP_ACS_REGION;
    var region = (fromEnv || (0, exports.getRegionFromUrl)() || envConsts_1.REGIONS.US).toUpperCase();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!Object.values(envConsts_1.REGIONS).includes(region)) {
        throw Error("Unknown 'region' value: " + fromEnv + ". Must be one of: " + Object.values(envConsts_1.REGIONS));
    }
    return region;
};
exports.getRegion = getRegion;
var envFromUrl;
var getEnvFromUrl = function () {
    if (envFromUrl) {
        return envFromUrl;
    }
    var currentHostname = window.location.href;
    if (!currentHostname) {
        return envFromUrl;
    }
    if (currentHostname.includes(stripProtocolFromUrl(envConsts_1.HOSTNAMES[envConsts_1.ENVS.QA])) ||
        currentHostname.includes(envConsts_1.BIM360_HOSTNAMES[envConsts_1.ENVS.QA])) {
        envFromUrl = envConsts_1.ENVS.QA;
    }
    if (currentHostname.includes(stripProtocolFromUrl(envConsts_1.HOSTNAMES[envConsts_1.ENVS.STAGING])) ||
        currentHostname.includes(stripProtocolFromUrl(envConsts_1.EMEA_HOSTNAMES[envConsts_1.ENVS.STAGING])) ||
        currentHostname.includes(envConsts_1.BIM360_HOSTNAMES[envConsts_1.ENVS.STAGING]) ||
        currentHostname.includes(envConsts_1.BIM360_EMEA_HOSTNAMES[envConsts_1.ENVS.STAGING])) {
        envFromUrl = envConsts_1.ENVS.STAGING;
    }
    if (currentHostname.includes(stripProtocolFromUrl(envConsts_1.HOSTNAMES[envConsts_1.ENVS.PRODUCTION])) ||
        currentHostname.includes(stripProtocolFromUrl(envConsts_1.EMEA_HOSTNAMES[envConsts_1.ENVS.PRODUCTION])) ||
        currentHostname.includes(envConsts_1.BIM360_HOSTNAMES[envConsts_1.ENVS.PRODUCTION]) ||
        currentHostname.includes(envConsts_1.BIM360_EMEA_HOSTNAMES[envConsts_1.ENVS.PRODUCTION])) {
        envFromUrl = envConsts_1.ENVS.PRODUCTION;
    }
    return envFromUrl;
};
var clearEnvFromUrl = function () {
    envFromUrl = undefined;
};
exports.clearEnvFromUrl = clearEnvFromUrl;
/**
 * Returns one of `ENVS` values according to `REACT_APP_ACS_ENV` environment variable.
 * Fallback to `QA` if not exist.
 */
var getEnv = function () {
    var fromEnv = process.env.REACT_APP_ACS_ENV;
    var env = (fromEnv || getEnvFromUrl() || envConsts_1.ENVS.QA).toUpperCase();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!Object.values(envConsts_1.ENVS).includes(env)) {
        throw Error("Unknown 'env' value: " + fromEnv + ". Must be one of: " + Object.values(envConsts_1.ENVS));
    }
    return env;
};
exports.getEnv = getEnv;
var init = function () {
    return warn('init method is no longer needed. Use REACT_APP_ASC_ENV & REACT_APP_ACS_REGION environment variables instead');
};
exports.init = init;
var getEnvValue = function (key) {
    var region = (0, exports.getRegion)();
    var env = (0, exports.getEnv)();
    if (envConsts_1.ENV_CONFIGS[region] &&
        envConsts_1.ENV_CONFIGS[region][env] &&
        envConsts_1.ENV_CONFIGS[region][env][key]) {
        return envConsts_1.ENV_CONFIGS[region][env][key];
    }
    else {
        throw new Error("Cannot find env config for env: " + env + ", region: " + region + " and key: " + key);
    }
};
exports.getEnvValue = getEnvValue;
var getLoginUrl = function () {
    var currentHostname = window.location.host;
    var isB360Url = currentHostname.includes(envConsts_1.BIM360_HOSTNAMES[envConsts_1.ENVS.QA]) ||
        currentHostname.includes(envConsts_1.BIM360_HOSTNAMES[envConsts_1.ENVS.STAGING]) ||
        currentHostname.includes(envConsts_1.BIM360_HOSTNAMES[envConsts_1.ENVS.PRODUCTION]) ||
        currentHostname.includes(envConsts_1.BIM360_EMEA_HOSTNAMES[envConsts_1.ENVS.STAGING]) ||
        currentHostname.includes(envConsts_1.BIM360_EMEA_HOSTNAMES[envConsts_1.ENVS.PRODUCTION]);
    if (currentHostname && isB360Url) {
        return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.B360_LOGIN_URL);
    }
    else {
        return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.LOGIN_URL);
    }
};
exports.getLoginUrl = getLoginUrl;
var getOxygenUrl = function () { return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.OXYGEN_URL); };
exports.getOxygenUrl = getOxygenUrl;
var getAdminUrl = function () { return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_URL); };
exports.getAdminUrl = getAdminUrl;
var getAdminV1Url = function () { return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_V1_URL); };
exports.getAdminV1Url = getAdminV1Url;
var getAdminApiUrl = function () { return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_API); };
exports.getAdminApiUrl = getAdminApiUrl;
var getAdminConstructionApiUrl = function () {
    return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_CONSTRUCTION_API);
};
exports.getAdminConstructionApiUrl = getAdminConstructionApiUrl;
var getRelationshipServiceUrl = function () {
    return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE_URL);
};
exports.getRelationshipServiceUrl = getRelationshipServiceUrl;
var getApigeeUrl = function () { return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.APIGEE_URL); };
exports.getApigeeUrl = getApigeeUrl;
var getAccHostname = function () { return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ACC_HOSTNAME); };
exports.getAccHostname = getAccHostname;
var getReportsV2Url = function () {
    return (0, exports.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.REPORTS_V2_URL);
};
exports.getReportsV2Url = getReportsV2Url;
